module.exports = __webpack_public_path__ + "static/media/CosAssessmentsSchoolWorkspace.03aa2ea5.png";